module.exports = __webpack_public_path__ + "static/media/lazyaz_app4_preview.438c927b.jpg";